import React, { useState } from 'react';

// components
import Form from '../../../components/Form/Form';

const formStyles = {
  document: { display: 'grid', gap: '20px', gridTemplateColumns: `auto 1fr auto 44px` },
};

const NewDealDocs = () => {
  const [document, setDocument] = useState({
    form: [
      [
        { type: 'select', label: 'Ð¢Ð¸Ð¿ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°', placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°' },
        { type: 'input', label: 'ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°', placeholder: 'ÐÐ°Ð¿ÑÐ¸Ð¼ÐµÑ, âÐÐ¾Ð³Ð¾Ð²Ð¾Ñ ÐºÑÐ¿Ð»Ð¸-Ð¿ÑÐ¾Ð´Ð°Ð¶Ð¸ ÐÐµÐºÐ¿ÑÐ»Ð°ÑÐ¾Ð²â' },
        { type: 'document', text: 'Ð¤Ð°Ð¹Ð» Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°', label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ' },
        { type: 'delete' },
      ],
    ],
  });

  const handleAddForm = () => {
    setDocument((prev) => ({
      ...prev,
      form: [...prev.form, prev.form[0]],
    }));
  };

  const handleDeleteForm = (e, formIndex) => {
    e.preventDefault();
    if (document.form.length > 1) {
      const filteredArray = document.form.filter((item, idx) => idx !== formIndex);
      setDocument((prev) => ({
        ...prev,
        form: filteredArray,
      }));
    }
  };

  return (
    <div style={{ padding: '10px 20px', backgroundColor: 'white', marginTop: '20px', border: '1px solid #E0E0E0' }}>
      {document.form.map((item, index) => (
        <Form
          key={index}
          inputs={document.form[index]}
          title={index === 0 ? 'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ' : false}
          grid={formStyles.document}
          addFormButton={index === document.form.length - 1 ? 'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÐµÑÐµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ Ðº ÑÐ´ÐµÐ»ÐºÐµ' : false}
          addForm={handleAddForm}
          deleteForm={(e) => handleDeleteForm(e, index)}
        />
      ))}
    </div>
  );
};

export default NewDealDocs;
